(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSource', AdvertisingSource);

    AdvertisingSource.$inject = ['$resource'];

    function AdvertisingSource ($resource) {
        var resourceUrl =  'api/advertising-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
